<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/child'
import PageHeader from '@components/page-header'

import { CommunicationsTable } from 'coryallen-communications';

export default {
  page: {
    title: 'Inbox',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, CommunicationsTable },
  data() {
    return {
      title: 'Inbox',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Inbox', to: '/inbox', },
        { text: '', active: true, },
      ],
      dsbl_btn: false,

      tabIndex: 0,

      loading: true,
      item: [],
      filters: {
        paginate: 1,
        page: 1,
        total: 0,
        wheres: {
          id: this.$route.params.id
        },
        withs: {
          user: {
            total: 0,
          },
          listing: {
            total: 0,
          },
          mlslisting: {
            total: 0,
          },
        },
      },

      communications_loading: true,
      communications_filters: {
        paginate: 50,
        page: 1,
        total: 0,
        types: ['Note', 'Activity'],
        only: '',
        onable_id: this.$route.params.id,
        onable_type: 'coryallen\\Inbox\\Models\\Inbox',
        /* byable_id: '1',
        byable_type: 'App\\User', */
      },

    }
  },
  created() {
    this.tabIndex = parseInt(window.location.hash.replace('#',''), 10);
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/inbox/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        if(res.data.data.length == 1) {
          this.item = res.data.data[0];
          this.title = this.items[2].text = this.item.subject;

          if(this.item.unseen) {
            this.$http.put('/api/inbox/update', {id: this.item.id, subject: this.item.subject, unseen: 0}).then(res => {
              // console.log(res);
              this.item.unseen = 0;
            }).catch(res => { this.popupErrors(res); });
          }

        } else {
          $this.$noty.warning("Content could not be found.");
          this.$router.push('/inbox');
        }
        this.loading = false;
      }).catch(res => { this.popupErrors(res); this.loading = false; });
    },
    delete_inbox() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.item.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }

      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this message?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> DELETE', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/inbox/delete/'+this.item.id).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              n.close();
              this.$router.push('/inbox');
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-tabs class="nav-bordered header-nav hide-content" lazy v-model="tabIndex">
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Details</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="communications_loading"></span> Notes & Activities</template></b-tab>
    </b-tabs>
    <div v-if="item.id">
      <div v-show="tabIndex == 0">
        <div class="row mt-4 set-sm-375">
          <div class="col-sm-4">
            <div class="card-box">
              <h5 class="section-header mb-3"><Icon icon="ri:book-2-line" /> About :</h5>
              <div class="table-responsive">
                <table class="table table-sm table-px-0">
                  <tbody>
                    <tr><th class="border-0"><label>Important :</label></th><td class="border-0 small"><div v-if="item.important" class="alert alert-success small mb-0 px-2 py-1">Yes</div><div v-else class="alert alert-danger small mb-0 px-2 py-1">No</div></td></tr>
                    <tr><th><label>Unseen :</label></th><td class="small"><div v-if="item.unseen" class="alert alert-success small mb-0 px-2 py-1">Yes</div><div v-else class="alert alert-danger small mb-0 px-2 py-1">No</div></td></tr>
                    <tr><th><label>Created Contact :</label></th><td class="small"><div v-if="item.created_contact" class="alert alert-success small mb-0 px-2 py-1">Yes</div><div v-else class="alert alert-danger small mb-0 px-2 py-1">No</div></td></tr>
                    <tr><th><label>Website :</label></th><td class="small">{{ item.website }}</td></tr>
                    <tr><th><label>Form type :</label></th><td class="small">{{item.type}}</td></tr>
                    <tr><th><label>IP Address :</label></th><td class="small">{{item.ip_address}}</td></tr>
                    <tr><th><label>Updated on :</label></th><td class="small" v-tippy :content="moment(item.updated_at).format('lll')">{{moment(item.updated_at).fromNow()}}</td></tr>
                    <tr><th><label>Created on :</label></th><td class="small" v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td></tr>
                  </tbody>
                </table>
              </div>
            </div>

            <router-link v-if="item.user && item.user.id" :to="'/contacts/'+item.user.id" tag="div" class="card-box grow" exact v-tippy content="View profile">
              <router-link :to="'/contacts/'+item.user.id" tag="a" class="text-dark d-block" exact>
                <div class="row m-0">
                  <div class="_w-60 mr-3">
                    <avatar :username="item.user.name" :src="formatImage(item.user.avatar)" :size="60" :rounded="false" class="rounded"></avatar>
                  </div>
                  <div class="col p-0 text-gray-700 _f-s-13 _lh-17">
                    <h5 class="m-0">{{ item.user.name }}</h5>
                    <div>{{ item.user.email }}</div>
                    <div>{{ formatPhone(item.user.phone) }}</div>
                  </div>
                </div>
              </router-link>
            </router-link>
            
            <router-link v-if="item.listing && item.listing.id"  :to="'/listings/'+item.listing.id" tag="a" class="grow d-block" exact v-tippy content="View listing">
              <w-listing-box :item="item.listing" class="border _box-shadow-0-1-4-b-2 mb-4"></w-listing-box>
            </router-link>

            <w-listing-box v-if="item.mlslisting && item.mlslisting.id" :item="item.mlslisting" class="border _box-shadow-0-1-4-b-2 mb-4"></w-listing-box>

            <button type="button" class="btn btn-block btn-outline-danger" @click="delete_inbox" :disabled="dsbl_btn"><Icon icon="ri:delete-bin-7-line" /> Delete Message</button>
          </div>
          <div class="col-sm-8">
            <div class="card-box">
              <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Message details :</h5>
              
              <div class="table-responsive">
                <table class="table table-sm table-px-0">
                  <tbody>
                    <tr><th class="border-0"><label>Subject :</label></th><td class="border-0 small">{{ item.subject }}</td></tr>
                    <tr><th><label>Message :</label></th><td class="small bg-gray-100 border-top-0 border-left border-primary _b-s-4 p-3">{{item.comments}}</td></tr>
                    <tr><th><label>Name :</label></th><td class="small">{{ item.name }}</td></tr>
                    <tr><th><label>Email :</label></th><td class="small">{{item.email}}</td></tr>
                    <tr><th><label>Friend Email :</label></th><td class="small">{{item.friend_email}}</td></tr>
                    <tr><th><label>Phone :</label></th><td class="small">{{ item.phone ? formatPhone(item.phone) : '' }}</td></tr>
                    <tr><th><label>Address :</label></th><td class="small">{{item.Address}}</td></tr>
                    <tr><th><label>City :</label></th><td class="small">{{item.City}}</td></tr>
                    <tr><th><label>State :</label></th><td class="small">{{item.StateOrProvince}}</td></tr>
                    <tr><th><label>Zip code :</label></th><td class="small">{{item.PostalCode}}</td></tr>
                    <tr><th><label>Latitude :</label></th><td class="small">{{item.Latitude}}</td></tr>
                    <tr><th><label>Longitude :</label></th><td class="small">{{item.Longitude}}</td></tr>
                    <tr><th><label>Bathrooms :</label></th><td class="small">{{item.BathroomsTotalInteger}}</td></tr>
                    <tr><th><label>Bedrooms :</label></th><td class="small">{{item.BedroomsTotal}}</td></tr>
                    <tr><th><label>SQFT :</label></th><td class="small">{{item.LivingArea}}</td></tr>
                    <tr><th><label>Acres :</label></th><td class="small">{{item.LotSizeAcres}}</td></tr>
                    <tr><th><label>Property type :</label></th><td class="small">{{item.PropertyType}}</td></tr>
                    <tr><th><label>Property sub type :</label></th><td class="small">{{item.PropertySubType}}</td></tr>
                    <tr><th><label>List price :</label></th><td class="small">{{ item.ListPrice ? formatPrice(item.ListPrice) : '' }}</td></tr>
                    <tr><th><label>Close price :</label></th><td class="small">{{ item.ClosePrice ? formatPrice(item.ClosePrice) : '' }}</td></tr>
                    <tr><th><label>MLS listing ID :</label></th><td class="small">{{item.ListingId}}</td></tr>
                    <tr><th><label>Buying :</label></th><td class="small">{{item.buying}}</td></tr>
                    <tr><th><label>Selling :</label></th><td class="small">{{item.selling}}</td></tr>
                    <tr><th><label>Has realtor :</label></th><td class="small">{{item.has_realtor}}</td></tr>
                    <tr><th><label>Pre qualified :</label></th><td class="small">{{item.pre_qualified}}</td></tr>
                    <tr><th><label>Offer amount :</label></th><td class="small">{{ item.offer_amount ? formatPrice(item.offer_amount) : '' }}</td></tr>
                    <tr><th><label>Valuations :</label></th><td>
                      <div class="table-responsive">
                        <table class="table table-sm table-px-0">
                          <tbody> 
                            <tr v-for="(valuation, valuation_i) in item.valuations" :key="valuation_i"><th :class="Object.keys(item.valuations)[0] == valuation_i ? 'border-0' : ''"><label>{{ valuation_i }} :</label></th><td  :class="Object.keys(item.valuations)[0] == valuation_i ? 'border-0' : ''">
                              <div class="table-responsive">
                                <table class="table table-sm table-px-0">
                                  <tbody>
                                    <tr v-for="(amount, amount_i) in valuation" :key="amount_i"><th :class="Object.keys(valuation)[0] == amount_i ? 'border-0' : ''"><label>{{ amount_i }} :</label></th><td class="small" :class="Object.keys(valuation)[0] == amount_i ? 'border-0' : ''">
                                      {{ amount && !isNaN(amount) ? formatPrice(amount, true, false) : '' }}
                                    </td></tr>
                                  </tbody>
                                </table>
                              </div>
                            </td></tr>
                          </tbody>
                        </table>
                      </div>
                    </td></tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div v-show="tabIndex == 1">
        <div v-if="communications_filters.onable_id" class="mt-3">
          <CommunicationsTable ref="CommunicationsTable" :filters="communications_filters" :user="user" :name="'title'" @loadchange="(e) => {communications_loading = e}"></CommunicationsTable>
        </div>
      </div>

    </div>
  </Layout>
</template>




